<script setup lang="ts">
import type {
  IFormBuilderReference,
  TModelValue,
  TTemplateName,
} from '~/interfaces/form/formBuilder';

withDefaults(
  defineProps<{
    templateName: TTemplateName;
    showTitle?: boolean;
    showSubTitle?: boolean;
    titleClasses?: string;
    subTitleClasses?: string;
    containerClasses?: string;
    formClasses?: string;
    inputContainerClasses?: string;
    stepContainerClasses?: string;
    elementContainerClasses?: string;
  }>(),
  {
    showTitle: false,
    showSubTitle: false,
    titleClasses: 'text-base-priority font-bold',
    subTitleClasses: 'text-sm',
    containerClasses: 'flex flex-col gap-2 max-w-[360px]',
    formClasses: '',
    inputContainerClasses: '',
    stepContainerClasses: '',
    elementContainerClasses: '',
  },
);
const model = defineModel<Partial<TModelValue>>();
const emits = defineEmits<{
  (e: 'error', error: string): void;
  (e: 'loaded'): void;
  (e: 'emptySchema'): void;
}>();
const form = ref<IFormBuilderReference>();
watch(
  () => form?.value?.loaded,
  (value) => !!value && emits('loaded'),
);
</script>
<template>
  <UserInterfaceDynamicFormBuilder
    ref="form"
    v-model="model"
    :template-name="templateName"
    :show-title="showTitle"
    :show-sub-title="showSubTitle"
    :title-classes="[{ [titleClasses]: !form?.isEmpty }]"
    :sub-title-classes="[{ [subTitleClasses]: !form?.isEmpty }]"
    :container-classes="[{ [containerClasses]: !form?.isEmpty }]"
    :element-container-classes="[{ [elementContainerClasses]: !form?.isEmpty }]"
    :input-container-classes="[{ [inputContainerClasses]: !form?.isEmpty }]"
    :step-container-classes="[{ [stepContainerClasses]: !form?.isEmpty }]"
    :form-classes="[{ [formClasses]: !form?.isEmpty }]"
    :should-auto-focus="false"
    @error="emits('error', $event)"
    @empty-schema="emits('emptySchema')"
  />
</template>
